import {
    AnalyticsFiltersProps,
    ViewAnalitycsType,
} from '../service/filters.interface';
import {
    FilterOption,
    PAGE_TYPE,
    PageType,
} from '../../../components/TabSwitcher/service/tabs.interface';

export const initialFilters = {
    tags_names: [],
    telegram_accounts: [],
    period: 'day',
    viewAnalitycsType: 'all' as ViewAnalitycsType,

    date_from: undefined,
    date_to: undefined,
    chat: undefined,

    is_chat_bot_source: true,
};

export const getCurrentPageSlug = (
    filters: AnalyticsFiltersProps
): PageType | null => {
    const map: Record<string, PageType> = {
        is_chat_bot_source: PAGE_TYPE.MANAGE,
        is_user_bot_source: PAGE_TYPE.MONITORING,
    };

    for (const key in map) {
        if ((filters as AnalyticsFiltersProps)[key]) {
            return map[key];
        }
    }

    return null;
};

export const getFilterPageTypeOptions = (
    items: FilterOption<PageType>[],
    filters: AnalyticsFiltersProps
) => {
    const currentSlug = getCurrentPageSlug(filters);

    return currentSlug
        ? items.filter(item => item.slug?.includes(currentSlug))
        : items;
};
